/* 위시리스트 **자가 복구** — 낡은 목록 번호 하나만 고친다. 그 외에는 아무것도 하지 않는다.

   ⛔ 덜어낸 이유 (2026-09-12 의장 「이젠 지혼자 켜졌다가 꺼졌다가」)
      한때 이 파일이 하트를 다시 칠했다. 앱 기억을 근거로 화면 전체를 칠했다가
      **엉뚱한 상품의 하트를 끄고**(「샴푸를 눌렀더니 미타임이 꺼졌어」),
      앱과 번갈아 칠하면서 **하트가 저 혼자 깜빡였다.**
      화면을 그리는 일은 앱의 몫이다. 우리가 끼어들면 둘이 싸운다.
      → 그리는 일에서 손을 뗀다. 라이브에서 잘 도는 그대로 두는 것이 낫다.

   남긴 것 하나 — 낡은 목록 번호 고치기
      브라우저에 저장된 위시리스트 목록 번호가 앱 서버에서 사라지면,
      앱은 계속 죽은 번호로 보내고 서버는 422 로 거절한다. 앱은 스스로 고치지 않아
      **그 브라우저에서는 영영 안 담긴다**(의장 화면에서 실측: 낡은 번호 5676143 → 422).
      고객도 같은 일을 겪는다. 그래서 이것만 막는다.

   하는 일은 **하나뿐**이다 (2026-09-12 의장 결정 「그렇게 해. 일지에게 넘겨」).
     422 가 오면 낡은 기록을 지우고 새로고침한 뒤, 담으려던 상품을 한 번 다시 담는다.
     한 세션에 한 번만 한다.

   ⛔ **화면을 그리는 일은 앱에게 돌려주었다.**
      한때 이 파일이 하트를 다시 칠했다. 그러다 엉뚱한 상품의 하트를 끄고
      (「샴푸를 눌렀더니 미타임이 꺼졌어」), 앱과 번갈아 칠하며 저 혼자 깜빡였다.
      우리가 끼어들면 둘이 싸운다. 라이브와 **같은 상태**로 두는 것이 낫다.

   ⚠ 그래서 남는 결함 두 가지는 **그대로 둔다.** 라이브도 똑같다(검사기로 대조 확인):
      · 뺀 뒤에 하트가 안 꺼진다 (새로고침해야 바뀐다)
      · 헤더 배지 숫자가 켜진 하트 수와 어긋난다
      이 둘은 **일지가 만들 앱에서 없앤다** — _output/4단계 요구사항 명세 참고. */
(function () {
  if (window.__ueWlGuard) return;
  window.__ueWlGuard = true;

  var 기록키 = ['th_wishlist_lists', 'th_wishlist_products_list', 'th_wlc_pro_count', 'th_default_settings_content'];
  var 한번만 = 'ue_wl_fixed';
  var 다시담을것 = 'ue_wl_retry';

  function 지우기() {
    try { 기록키.forEach(function (k) { localStorage.removeItem(k); }); } catch (e) {}
  }

  var of = window.fetch;
  window.fetch = function () {
    var u = String(arguments[0] || '');
    var opt = arguments[1] || {};
    var p = of.apply(this, arguments);

    if (/webcontrive/i.test(u) && (u.indexOf('/add') > -1 || u.indexOf('/remove') > -1)) {
      var 상품 = null;
      try { if (typeof opt.body === 'string') 상품 = JSON.parse(opt.body).product_id; } catch (e) {}
      p.then(function (r) { return r.clone().text(); })
       .then(function (t) {
          var j = null;
          try { j = JSON.parse(t); } catch (e) { return; }

          if (!j || j.status !== 422) return;   /* 잘 됐으면 **아무것도 하지 않는다** */
          var 이미 = false;
          try { 이미 = sessionStorage.getItem(한번만) === '1'; } catch (e) {}
          if (이미) return;
          try {
            sessionStorage.setItem(한번만, '1');
            if (상품) sessionStorage.setItem(다시담을것, String(상품));
          } catch (e) {}
          지우기();
          location.reload();
       })
       .catch(function () {});
    }
    return p;
  };

  /* 새 목록을 받은 뒤, 담으려던 상품을 한 번만 다시 담는다 */
  function 다시담기() {
    var id = null;
    try { id = sessionStorage.getItem(다시담을것); } catch (e) {}
    if (!id) return;
    try { sessionStorage.removeItem(다시담을것); } catch (e) {}
    var 시도 = 0;
    var 타이머 = setInterval(function () {
      if (++시도 > 20) { clearInterval(타이머); return; }
      var 상자 = document.querySelector('.th_wl_col_btn[data-product_id="' + id + '"]');
      var 단추 = 상자 && 상자.querySelector('.th_wl_button');
      var 목록 = null;
      try { 목록 = localStorage.getItem('th_wishlist_lists'); } catch (e) {}
      if (!단추 || !목록) return;
      clearInterval(타이머);
      단추.click();
    }, 500);
  }

  if (document.readyState === 'complete') 다시담기();
  else window.addEventListener('load', 다시담기);
})();
